/**
 * @export
 * @param {*} url
 * @param {*} [params={}]
 * @return {*}
 */
export function resizeUrl(url, params = {}) {
  return `get/image/${url}?${new URLSearchParams(params).toString()}`
}
